import React from "react";
import { ReactTyped } from "react-typed";
import heavenly from "../assets/heavenly.png";

const Hero = () => {
  return (
    <section id="home" className="relative flex min-h-screen items-center justify-center overflow-hidden">
      {/* Background image */}
      <img
        src={heavenly}
        alt="Sunlight breaking through golden clouds"
        className="absolute inset-0 h-full w-full object-cover"
      />
      {/* Readability overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-maroon-dark/70 via-maroon/40 to-ink/70" />

      {/* Content */}
      <div className="relative z-10 mx-auto max-w-3xl px-4 pt-20 text-center text-white animate-fade-up">
        <p className="section-label text-peach drop-shadow">The Little Flock Tabernacle</p>

        <h1 className="mt-4 font-serif text-5xl font-bold leading-tight drop-shadow-lg sm:text-6xl md:text-7xl">
          Welcome
        </h1>

        <ReactTyped
          className="mt-6 block text-lg font-medium italic text-peach drop-shadow-lg sm:text-xl md:text-2xl"
          strings={[
            "“Fear not, little flock; for it is your Father's good pleasure to give you the kingdom.” — Luke 12:32",
          ]}
          typeSpeed={25}
          showCursor={false}
        />

        <div className="mt-9 flex flex-col items-center justify-center gap-4 sm:flex-row">
          <a href="#visit" className="btn-primary w-full sm:w-auto">
            Plan Your Visit
          </a>
          <a href="#watch" className="btn-secondary w-full sm:w-auto">
            Watch Online
          </a>
        </div>
      </div>

      {/* Scroll cue */}
      <a
        href="#about"
        aria-label="Scroll to learn more"
        className="absolute bottom-6 left-1/2 z-10 -translate-x-1/2 text-white/80 transition hover:text-white"
      >
        <span className="block h-10 w-6 rounded-full border-2 border-white/70">
          <span className="mx-auto mt-2 block h-2 w-1 animate-bounce rounded-full bg-white/90" />
        </span>
      </a>
    </section>
  );
};

export default Hero;
